/* eslint-disable one-var */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/*
 * Copyright (c) 2021 Mailtech.cn, Ltd. All Rights Reserved.
 */

// modified IDEA-Cipher implementation from https://github.com/mytecor/idea-cipher

function ideaExpandKeys(/** int[] */keys) {
  // The remaining 44 subkeys are filled in
  for (let i = 8; i < 52; i++) {
    // There is a left rotation of 25 bits
    keys[i] = add(keys[i - ((i + 1) % 8 ? 7 : 15)] << 9, keys[i - ((i + 2) % 8 < 2 ? 14 : 6)] >> 7);
  }
  return keys;
}

function ideaInvertKeys(/** int[] */keys) {
  let invKeys = [], p = 0;

  // Round 9 (Final Transformation)
  invKeys[48] = modInv(keys[p++]);
  invKeys[49] = addInv(keys[p++]);
  invKeys[50] = addInv(keys[p++]);
  invKeys[51] = modInv(keys[p++]);

  // Rounds [8 - 2]
  for (let r = 7; r > 0; r--) {
    let i = r * 6;
    invKeys[i + 4] = keys[p++];
    invKeys[i + 5] = keys[p++];
    invKeys[i] = modInv(keys[p++]);
    invKeys[i + 2] = addInv(keys[p++]);
    invKeys[i + 1] = addInv(keys[p++]);
    invKeys[i + 3] = modInv(keys[p++]);
  }

  // Round 1
  invKeys[4] = keys[p++];
  invKeys[5] = keys[p++];
  invKeys[0] = modInv(keys[p++]);
  invKeys[1] = addInv(keys[p++]);
  invKeys[2] = addInv(keys[p++]);
  invKeys[3] = modInv(keys[p]);

  return invKeys;
}

function ideaCipher(/** byte[] */dv, offset, /** int[] */keys) {
  let x1 = getUint16(dv, offset);
  let x2 = getUint16(dv, offset + 2);
  let x3 = getUint16(dv, offset + 4);
  let x4 = getUint16(dv, offset + 6);

  let k = 0; // Round-by-round crawl
  for (let round = 0; round < 8; round++) {
    let y1 = mul(x1, keys[k++]); // K1
    let y2 = add(x2, keys[k++]); // K2
    let y3 = add(x3, keys[k++]); // K3
    let y4 = mul(x4, keys[k++]); // K4

    // MA-box
    let p = y1 ^ y3;
    let q = y2 ^ y4;

    let a = mul(p, keys[k++]); // K5
    let b = add(q, a);
    let t = mul(b, keys[k++]); // K6
    let u = add(a, t);

    x1 = y1 ^ t;
    x2 = y3 ^ t;
    x3 = y2 ^ u;
    x4 = y4 ^ u;
  }

  setUint16(dv, offset, mul(x1, keys[48]));
  setUint16(dv, offset + 2, add(x3, keys[49]));
  setUint16(dv, offset + 4, add(x2, keys[50]));
  setUint16(dv, offset + 6, mul(x4, keys[51]));
}

function ECB(blockCipher, data, keys) {
  // The length is extended to the desired size
  let offset = (data.length + 7) & ~7; // toInt((data.length + 7) / 8)

  // Passing through the blocks
  while (offset) {
    blockCipher(data, offset -= 8, keys);
  }

  return data;
}

const encryptionKeys = [0x3bc0, 0xc1b7, 0xc004, 0x7b6d, 0x442f, 0xf672, 0x7bcc, 0xc446];
module.exports = {
  encrypt: (keys => data => {
    return ECB(ideaCipher, data, keys)
  })(ideaExpandKeys(encryptionKeys)),
  decrypt: (keys => data => {
    return ECB(ideaCipher, data, keys)
  })(ideaInvertKeys(encryptionKeys))
}

// Ops
function modInv(a) {
  let m = 0x10001;
  let m0 = m, y = 0, x = 1;

  while (a > 1) {
    let q = (a / m) | 0; // https://stackoverflow.com/questions/4228356/how-to-perform-an-integer-division-and-separately-get-the-remainder-in-javascr/4228528#4228528
    let t = m;

    m = a % m;
    a = t;
    t = y;

    y = x - q * y;
    x = t;
  }

  return x < 0 ? x + m0 : x;
}

function mul(a, b) {
  let m = a * b;
  if (m) return (m % 0x10001) & 0xFFFF;
  if (a || b) return (1 - a - b) & 0xFFFF;
  return 1;
}

function addInv(x) {
  return (0x10000 - x) & 0xFFFF;
}

function add(x, y) {
  return (x + y) & 0xFFFF;
}

function getUint16(data, offset) {
  return add(data[offset] << 8, data[offset + 1] | 0);
}

function setUint16(data, offset, value) {
  data[offset] = value >> 8;
  data[offset + 1] = value & 255;
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/xcm-cipher.js